import type { FaireProductEntity } from "../../entity_types/product";

export const p_xn53wrpr5m: FaireProductEntity = {
  token: "p_xn53wrpr5m",
  type: "product",
  name: "Earl Grey Remix",
  brandToken: "b_6su5v1sirt",
  brandName: "Highwire Coffee Roasters",
  imageUrl: "https://cdn.faire.com/fastly/e154e8e2e8019dd17e46e19b8484b5a85060fb88d5e735b37d8b11dd13a1f5cd.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/49947c2f06dcf23aa108a005538ac90aad926d5c113830d2a713a6f5abdce8b7.jpeg",
    "https://cdn.faire.com/fastly/9ff6d1f7b682177e9314fc9b46af9d17f5192603504a9864edf62e89c3212664.png"
  ],
  priceDollars: 10.5,
  description: "\nProfile: Bright, candied lemon, floral. We found a candied lemon briskness on a floral tea base and combined that with a Yunnan tea and rose petals. The result is a fully flavored Earl Grey with more black tea resonance than any other we’ve tasted.\n\n\n\n\n\nProfile: Bright, candied lemon, floral\n\n\n\nThis tea was inspired by the fact that Earl Grey teas always felt lacking, too simple, and too one dimensional. We cupped a couple dozen samples of different black tea bases, plus levels and shades of bergamot flavoring to get to the profile that resonated: a candied lemon briskness on a floral tea base.\n\nWe combined that with a sturdy, structured Yunnan to ground it, and rose petals to add aromatic complexity. The result is a fully flavored Earl Grey with more black tea resonance than any other Earl Grey we’ve tasted.\n\n\n\nWe recommend brewing 1g of tea in 2oz of water at 210° for 4 minutes\n\n\n",
  tags: [],
  msrpDollars: 15,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:58:13.830Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
